<template>
    <div class="progress-bar-top" :style="style" :ui-loading="progress < 100 ? 'true' : 'false'"/>
</template>

<script type="javascript">
	import interval from '../helpers/interval';
	
	export default {
		name: 'progress-bar',
		props: {
			running: {
				type: Boolean,
				required: true
			}
		},
		data() {
			return {
				progress: 0,
				interval: null,
				style: {
					opacity: 0
				}
			};
		},
		watch: {
			running() {
				this[this.running ? 'start' : 'stop']();
			}
		},
		beforeMount() {
			if (this.running) {
				this.start();
			}
		},
		beforeDestroy() {
			if (this.interval) {
				this.interval.stop();
			}
		},
		methods: {
			start() {
				this.progress = 0;
				this.style = {
					transition: 'width 0s, opacity 0s',
					opacity: 1,
					width: `${this.progress}%`
				};
				this.interval = interval(this.increase, 300);
			},
			increase() {
				const {progress} = this.progress;
				let perc;
	
				this.style.transition = 'width 0.3s linear';
	
				if (progress >= 0 && progress < 25) {
					perc = Math.random() * 10;
				} else if (progress >= 25 && progress < 65) {
					perc = Math.random() * 7;
				} else if (progress >= 65 && progress < 90) {
					perc = Math.random() * 2;
				} else if (progress >= 90 && progress < 99) {
					perc = 0.25;
				} else {
					perc = 0;
				}
	
				this.progress += Math.round(perc * 10) / 10;
				this.style.width = `${this.progress || 1}%`;
			},
			stop() {
				this.progress = 100;
				this.interval.stop();
	
				_.extend(this.style, {
					transition: 'width 0.6s cubic-bezier(0.7, 0, 0.3, 1), opacity 2s cubic-bezier(0.7, 0, 0.3, 1)',
					opacity: 0,
					width: `${this.progress}%`
				});
			}
		}
	};
</script>
